/**
 * @desc: 保理利润
 * @created: 2020/09/04
 * @author: Colorfule
 * @version: v1.0
 */

import request from '@/plugins/http'

export const getListData = params => {
  return request.get('/quota/qverdue/list', params)
}

// 获取详情页列表
export const getDetailList = params => {
  return request.get('/quota/qverdue/detail/list', params)
}